var SortableModule = /** @class */ (function () {
    function SortableModule() {
    }
    return SortableModule;
}());
export { SortableModule };
